<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="Esop修改记录"
      top="5vh"
      width="800px"
      @close="closePage">
    <div>
      <el-button type="primary" style="margin-bottom:5px" @click="$refs.editPage.open(0)">上传附件</el-button>
    </div>
    <el-table :loading="tableLoading" :data="esopVo.changeDetailVOS">
      <el-table-column label="图片" prop="imgPath" align="center" width="240">
        <template slot-scope="scope">
          <span style="cursor: pointer;color:#2d8cf0" @click="imgPreview(scope.row.imgPath)">{{scope.row.imgPath}}</span>
        </template>
      </el-table-column>
      <el-table-column label="描述" prop="note" align="center" width="240"/>
      <el-table-column label="创建人" prop="creatorName" align="center" width="120"/>
      <el-table-column label="创建时间" prop="createTime" align="center" width="160"/>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button :disabled="scope.row.creatorId !== userId" type="primary" @click="$refs.editPage.open(scope.row,scope.$index)">编辑</el-button>
          <el-button :disabled="scope.row.creatorId !== userId" type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <file-upload ref="editPage" @save-success="editRow"/>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit(0)">保存</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit(1)">提交</el-button>
    </span>
    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        @closeClick="
          () => {
            photoVisible = false
          }
        "/>
  </el-dialog>
</template>

<script>
  import fileUpload from "./FileUpload";
  import BigImg from "@/components/BigImg";
  import loginUtil from "@/util/loginUtil";
  export default {
    components:{fileUpload,BigImg},
    data() {
      return {
        dialogVisible:false,
        submitLoading:false,
        photoVisible:false,
        tableLoading:true,
        bigImgUrl:"",
        userId:loginUtil.getUserId(),
        pkId:"",
        esopVo:[],
      };
    },

    methods:{
      open(id) {
        this.pkId = id;
        this.dialogVisible = true;
        this.getEsopChangeData();
      },

      getEsopChangeData() {
        this.$http.get("basic",`esopChanges/getByEsopId/${this.pkId}`).then((res)=>{
          if(res.data) {
            this.esopVo = res.data;
            this.esopVo.changeDetailVOS = res.data.changeDetailVOS ? res.data.changeDetailVOS : [];
            this.esopVo.changeType = 30;
            this.esopVo.approveType = 30;
            this.esopVo.esopId = this.pkId;
            this.tableLoading =false;
          }
        });
      },

      showBigImage(e) {
        //点击图片函数，点击后，把photoVisible设置成true
        if (e != "") {
          this.photoVisible = true;
          this.bigImgUrl = e.currentTarget.src;
        }
      },

      deleteRow(index) {
        this.esopVo.changeDetailVOS.splice(index, 1);
      },  

      editRow(row) {
        let rowInfo = {
          createTime:this.getNowTime(),
          creatorId:loginUtil.getUserId(),
          creatorName:loginUtil.getName(),
          note:row.note,
        };
        if(row.isCreated) {
          rowInfo.imgPath = row.imgPath;
          rowInfo.imgUrl = row.imgUrl;
          this.esopVo.changeDetailVOS.push(rowInfo);
        } else{
          if(row.imgPath && row.imgUrl) {
            this.esopVo.changeDetailVOS[row.index].imgUrl = row.imgUrl;
            this.esopVo.changeDetailVOS[row.index].imgPath = row.imgPath;
            this.esopVo.changeDetailVOS[row.index].note = row.note;
            this.esopVo.changeDetailVOS[row.index].createTime = this.getNowTime();
          }
        }
        
      },

      getUrl(imgPath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(imgPath)}`).then((res) => {
          if (res.success) {
            this.bigImgUrl = res.data;
            this.photoVisible = true;
          }
        });
      },

      getNowTime() {
        const yy = new Date().getFullYear();
        const MM = (new Date().getMonth() + 1) < 10 ? "0" + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
        const dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate();
        const HH = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
        const mm = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
        const ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
        return yy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss;
      },

      handleSubmit(type) {
        this.$http.post("basic",`esopChanges/save/${type}`,this.esopVo).then((res)=>{
          if(res.success) {
            this.$message.success(type ? "提交成功" : "保存成功");
            this.dialogVisible = false;
          }
        });
      },

      imgPreview(path) {
        this.getUrl(path);
      },

      closePage() {
        this.esopVo = [];
      },
    },
  };
</script>

<style>

</style>